import BookingStore from './BookingStore';
import UserStore from './UserStore';
import ReservationStore from './ReservationStore';
import ReviewsStore from './ReviewsStore';
import ExamCenterReviewStore from './ExamCenterReviewStore';
import MeetingStore from './MeetingStore';
import SchoolReviewStore from './SchoolReviewStore';
import ExamCentersSearchStore from './ExamCentersSearchStore';
import TheoryAccessStore from './TheoryAccessStore';
import ProductsPageStore from './ProductsPageStore';
import TheoryAccessProvidersReviewsStore from './TheoryAccessProvidersReviewsStore';
import ExamSearchResultStore from './ExamSearchResultStore';
import CPFOffersStore from './CPFOffersStore';
import EditMeetingsStore from './EditMeetingsStore';
import InsuranceStore from './InsuranceStore';
import TeamReviewStore from './TeamReviewStore';
import LeadsStore from './LeadsStore';
import AnnoncesSearchResultStore from './AnnoncesSearchResultStore';
import NetworksReviewsStore from './NetworksReviewsStore';
import OpenDrivingSchoolStore from './OpenDrivingSchoolStore';
import OpenDrivingSchoolProposalStore from './OpenDrivingSchoolProposalStore';
import RecoveryPointsStore from './RecoveryPointsStore';
import DemarcheFunnelStore from './DemarcheFunnelStore';
import DemarcheCasesStore from './DemarcheCasesStore';

const stores = {
  bookingStore: BookingStore,
  userStore: UserStore,
  reservationStore: ReservationStore,
  reviewsStore: ReviewsStore,
  examCenterReviewStore: ExamCenterReviewStore,
  meetingStore: MeetingStore,
  editMeetingsStore: EditMeetingsStore,
  schoolReviewStore: SchoolReviewStore,
  examCentersSearchStore: ExamCentersSearchStore,
  theoryAccessStore: TheoryAccessStore,
  productsPageStore: ProductsPageStore,
  theoryAccessProvidersReviewsStore: TheoryAccessProvidersReviewsStore,
  examSearchResultStore: ExamSearchResultStore,
  cpfOffersStore: CPFOffersStore,
  insuranceStore: InsuranceStore,
  teamReviewStore: TeamReviewStore,
  leadsStore: LeadsStore,
  annoncesSearchResultStore: AnnoncesSearchResultStore,
  networksReviewsStore: NetworksReviewsStore,
  openDrivingSchoolStore: OpenDrivingSchoolStore,
  openDrivingSchoolProposalStore: OpenDrivingSchoolProposalStore,
  recoveryPointsStore: RecoveryPointsStore,
  demarcheFunnelStore: DemarcheFunnelStore,
  demarcheCasesStore: DemarcheCasesStore,
};

export default stores;
